import React, { useState } from "react";
import apiService from "../../services/ApiService";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
import TailwindInput from "../../components/Tailwind/TailwindInput";
import TailwindButton from "../../components/Tailwind/TailwindButton";

const ReportForgottenPassword = ({ back_to_login }) => {
  const [emailSent, setEmailSent] = useState(false);

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email must be a valid email address")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: SignupSchema,
    onSubmit: () => {
      setTimeout(() => {
        apiService.reportForgottenPassword(values.email).then((response) => {
          if (response) {
            setSubmitting(false);
            setEmailSent(true);
          }
        });
      }, 500);
    },
  });

  const { errors, touched, values, handleSubmit, isSubmitting, getFieldProps, setSubmitting, setFieldValue } = formik;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden">
          {/* Header */}
          <div className="px-8 pt-10 pb-6 text-center">
            <img
              width="220"
              height="68"
              src="/logo-text-black.png"
              alt="Peerception"
              className="mx-auto mb-6"
            />
            <div className="size-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
              <span className="material-symbols-outlined text-[28px] text-amber-600">lock_reset</span>
            </div>
            <h1 className="text-xl font-bold text-slate-900">Reset your password</h1>
            <p className="text-sm text-slate-500 mt-1">
              Enter your email address and we'll send you a reset link
            </p>
          </div>

          {/* Body */}
          <div className="px-8 pb-8">
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="flex flex-col gap-4">
                  <TailwindInput
                    fullWidth
                    autoComplete="username"
                    type="email"
                    label="Email address"
                    placeholder="you@example.com"
                    {...getFieldProps("email")}
                    error={touched.email && errors.email ? String(errors.email) : undefined}
                    onChange={(e) => {
                      setFieldValue("email", e.target.value);
                      setEmailSent(false);
                    }}
                  />

                  {emailSent && (
                    <div className="flex items-center gap-2 p-3 rounded-lg text-sm bg-green-50 text-green-800 border border-green-200">
                      <span className="material-symbols-outlined text-[18px] shrink-0">check_circle</span>
                      If you have an account, you will receive an email to reset your password.
                    </div>
                  )}

                  <TailwindButton
                    fullWidth
                    size="lg"
                    type="submit"
                    variant="dark"
                    icon="send"
                    disabled={isSubmitting}
                    className="mt-1"
                  >
                    {isSubmitting ? 'Sending...' : 'Send reset link'}
                  </TailwindButton>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <button
            onClick={() => back_to_login()}
            className="text-sm font-semibold text-primary hover:text-blue-700 transition-colors"
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportForgottenPassword;
